// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1a6A2","top":"styles_top__2SQK6","left":"styles_left__18E4a","description":"styles_description__3pm4u"};